 $('.veda-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,          // next/prev buttons
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button class="slick-prev">&#10094;</button>',
    nextArrow: '<button class="slick-next">&#10095;</button>'
  });

//   $('body').on('click','ul.login--egister--button li',function () {
//     var getAttribute = $(this).attr('data-attr');
//     $('.veda-custom--tabs').hide();
//     $(`.veda-custom--tabs[data-attr=${getAttribute}]`).show();
// })